<template>
    <BModal :model-value="modal" scrollable centered @update:modelValue="updateModal">
    <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Activity</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="$emit('updateModal', false)"
            >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <BForm>
            <BContainer>
                
                <BRow>
                    <BCol>
                        <BFormSelect v-model="selectDestination.selected" :options="selectDestination.data"></BFormSelect>
                    </BCol>
                    <BCol>
                        <BFormInput type="text" id="input-1" v-model="contact" :state="state" placeholder="Activity Name" class="form-group" />
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BFormInput type="number" id="input-1" v-model="contact" :state="state" placeholder="Price" class="form-group" />
                    </BCol>
                </BRow>

            </BContainer>
            
                
        
        </BForm>
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary"  class="mr-2">Save</BButton>
                <BButton variant="danger" @click="$emit('updateModal', false)">Cancel</BButton>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal,BRow, BCol, BForm, BFormInput, BButton, BFormSelect } from 'bootstrap-vue-next';
import { ref,reactive } from 'vue'

export default{
    name : 'AccommodationForm',
    components : { BModal,BRow, BCol, BForm, BFormInput, BButton, BFormSelect },
    props : {
        modal: Boolean,
    },
    setup(props, { emit }){

        const optionDefault = ref('')
        const selectDestination = reactive({
            selected : '-',
            data : [
                {value : '-', text : 'Choose Destination'},
                {value : 'MDN', text : 'MDN'},
                {value : 'BKL', text : 'BKL'},
            ]
        })
        const updateModal = (value) => {
            emit("update:modal", value); // Sync modal state with parent
        };
        return { 
            optionDefault,
            selectDestination,
            updateModal
        }
    }
}

</script>

